import React, {useState} from "react";
import {useForm} from "react-hook-form";
import {Container, Row, Col, Modal, Button} from "react-bootstrap";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import PhoneInput from 'react-phone-input-2';
import es from 'react-phone-input-2/lang/es.json';
import 'react-phone-input-2/lib/bootstrap.css';
import "../styles/components/contactform.css";

export const ContactForm = () => {
  const [show, setShow] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleClose = () => setShow(false);

  const handleCloseError = () => setShowError(false);

  const {register, handleSubmit, errors} = useForm();
 
  const [phone, setPhone] = useState()

  const endpoint = "https://a4hxub1zqc.execute-api.us-east-1.amazonaws.com/default/LambdaFunctionSendEmail"
  

  const onSubmit = (data, e) => {
    console.log(data);

    const body = JSON.stringify({
      senderName: data.firstName,
      senderLastname: data.lastName,
      senderEmail: data.email,
      senderPhone: data.phone_aux,
      senderType: data.type,
      message: data.comment
    })
    const requestOptions = {
      method: "POST",
      body
    }
    
    e.target.reset();

    fetch(endpoint, requestOptions)
      .then((response) => {
        if(!response.ok) throw new Error ("Error in fetch");
        return response.json()
        
      })
      .then((response) => {
        console.log("Email Sent")
        setShow(true)
      })
      .catch((error) => {
        console.log("Error")
        setShowError(true)
      })
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} >
        <Modal.Header closeButton  className="correctModal">
          <Modal.Title>Correo enviado correctamente</Modal.Title>
        </Modal.Header>
        <Modal.Body>¡Gracias por contactarnos. Responderemos a la brevedad!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showError} onHide={handleCloseError} >
        <Modal.Header closeButton  className="errorModal">
          <Modal.Title>Error al enviar</Modal.Title>
        </Modal.Header>
        <Modal.Body>Ha ocurrido un error. Revise que los datos sean correctos e intente nuevamente</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
  
      <Container className="fablab-container" id="contacto">
        <Row>
          <Col>
              <h1 className="fablab-title">Contacto</h1>
              <h2 className="fablab-subtitle text-center">Para membresías, dudas, problemas e ideas, mande un mensaje y nos contactaremos a la brevedad</h2>
          </Col>

          <Col xs={12}>
            <div className="wrapper">
                <form onSubmit={handleSubmit(onSubmit)}>  
                
                  <div className="firstName-section">
                    <label className="contact-formlabel">Nombre</label>           
                    <input 
                      name="firstName" 
                      className={(errors.firstName && "contact-forminput firstName error") || "contact-forminput firstName"}
                      placeholder="Ingrese su nombre"
                      ref={register({ required: true, 
                                  minLength: 3,
                                  pattern: {
                                    value: /^[^0-9]+$/
                                  }})} 
                    />
                    {errors.firstName && (errors.firstName.type === "required") && (
                    <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Este campo es requerido</p>
                    )}
                    {errors.firstName && (errors.firstName.type === "minLength") && (
                      <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Longitud mínima de 3</p>
                    )}
                    {errors.firstName && (errors.firstName.type === "pattern") && (
                      <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Respuesta inválida</p>
                    )}
                  </div>

                  <div className="lastName-section">
                    <label className="contact-formlabel">Apellido</label>
                    <input 
                      name="lastName" 
                      className={(errors.lastName && "contact-forminput lastName error") || "contact-forminput lastName"}
                      placeholder="Ingrese su apellido"
                      ref={register({ required: true, 
                                      minLength: 3,
                                      pattern: {
                                        value: /^[^0-9]+$/
                                      }})} 
                    />
                    {errors.lastName && (errors.lastName.type === "required") && (
                      <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Este campo es requerido</p>
                    )}
                    {errors.lastName && (errors.lastName.type === "minLength") && (
                      <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Longitud mínima de 3</p>
                    )}
                    {errors.lastName && (errors.lastName.type === "pattern") && (
                      <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Respuesta inválida</p>
                    )}
                  </div>

                  <div className="email-section">
                    <label className="contact-formlabel">Correo electrónico</label>
                    <input 
                      name="email" 
                      className={(errors.email && "contact-forminput email error") || "contact-forminput email"}
                      placeholder="Ingrese su correo electrónico" 
                      ref={register({ required: true, 
                                      pattern: {
                                        value: /[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]+/
                                      }
                                    })
                          } 
                    />
                    {errors.email && (errors.email.type === "required") && (
                      <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Este campo es requerido</p>
                    )}
                    {errors.email && (errors.email.type === "pattern") && (
                      <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Respuesta inválida</p>
                    )}
                  </div>

                  <div className="phone-section">
                    <label className="contact-formlabel">Número de contacto</label>

                    <PhoneInput
                    className="input-phone"
                    name = "phone" 
                    ref = {register}
                    placeholder= "Ingrese su número de contacto"
                    value= {phone}
                    onChange={setPhone}

                    country={'cl'}
                    enableSearch= {true}
                    localization={es}
                    searchPlaceholder="Buscar país"
                    searchNotFound="País no encontrado"
                    
                    inputStyle={{
                      width: 'inherit',
                      height: '45px',
                      borderBottom: 'solid #ececec 1px',
                      padding: '10px 20px 10px 58px',                    
                      borderRadius: '100 px',
                      marginBottom: '10px',
                      textAlign:"left"
                    }}
                    />
                    {errors.phone_aux && (
                    <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Este campo es requerido</p>
                    )}

                    <input
                    name="phone_aux"
                    type="hidden"
                    value={phone}
                    ref={register({ required: true})
                    } //input oculto para tomar la data
                    />
                  </div>

                  <div className="type-section">
                    <label className="contact-formlabel">Usted es</label>
                    <select 
                      name="type"
                      className={(errors.type && "contact-forminput type error") || "contact-forminput type"}
                      ref={register({ required: true })}
                    >
                      <option value="">Seleccione</option>
                      <option value="Estudiante">Estudiante UTFSM</option>
                      <option value="Profesor">Académico UTFSM</option>
                      <option value="Empresa">Empresa</option>
                      <option value="Persona">Persona natural</option>
                    </select>
                    {errors.type && (errors.type.type === "required") && (
                      <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Este campo es requerido</p>
                    )}
                  </div>

                  <div className="comment-section">
                    <label className="contact-formlabel">Comentario</label>
                    <textarea 
                      name="comment" 
                      placeholder="Ingrese su comentario" 
                      className={(errors.comment && "contact-forminput comment error") || "contact-forminput comment"}
                      ref={register({ required: true, 
                                      minLength: 15 })} 
                    />
                    {errors.comment && (errors.comment.type === "required") && (
                      <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Este campo es requerido</p>
                    )}
                    {errors.comment && (errors.comment.type === "minLength") && (
                      <p className="errorMessage"><FontAwesomeIcon icon={faExclamationTriangle} color="red"></FontAwesomeIcon> Longitud mínima de 15</p>
                    )}
                  </div>

                  <div className="contact-us">
                    <input className="fablab-button" type="submit"/>
                  </div>
                </form>
              </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
